import { getQuery } from '@bilibili/magic-bag/url';
import { SOURCE_TYPE, SOURCE_CONFIG, DEFAULT_SOURCE_FROM } from './constants';

export function getQueryParam(key) {
    const hash = window.location.hash;
    const urlQuery = getQuery(hash);
    return urlQuery[key] || '';
}

export function getSourceConfig() {
    const sourceType = getQueryParam('source_type') || SOURCE_TYPE.SHOP;
    return SOURCE_CONFIG[sourceType];
}

export function getSourceType() {
    return getQueryParam('source_type') || SOURCE_TYPE.SHOP;
}

export function getSourceFrom() {
    return getQueryParam('source_from') || DEFAULT_SOURCE_FROM;
}

export function getParamsNum(list, fn) {
    if (!list || !list.length) {
        return [null, null];
    }
    return list.map(item => fn(item));
}

export function handleRateMoney(commissionInfo) {
    if (!commissionInfo) {
        return commissionInfo;
    }
    const { commission = 0, commissionRate = 0 } = commissionInfo;
    return {
        commission: commission / 100,
        commissionRate: (commissionRate * 100).toFixed(2).replace(/\.00$/, '')
    };
}
